import {
  Box,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { ComponentType, FC } from "react";
import { useTranslation } from "react-i18next";

export interface ProviderOption {
  id: string;
  name: string;
  icon: ComponentType;
  color: string;
  description: string;
  tokenLabel: string;
  tokenPlaceholder: string;
  tokenHelperText: string;
  showSecondaryToken: boolean;
  metadataFields?: MetadataField[];
}

export interface MetadataField {
  key: string;
  label: string;
  type: 'text' | 'number' | 'checkbox' | 'textarea';
  placeholder?: string;
  helperText?: string;
  defaultValue?: any;
  required?: boolean;
}

interface ProviderSelectionProps {
  providers: ProviderOption[];
  selectedProvider: ProviderOption | null;
  onProviderSelect: (provider: ProviderOption) => void;
}

const ProviderSelection: FC<ProviderSelectionProps> = ({
  providers,
  selectedProvider,
  onProviderSelect,
}) => {
  const { t } = useTranslation();
  const textColor = useColorModeValue("#1A202C", "alphaWhite.600");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  return (
    <FormControl>
      <FormLabel>{t("partner.integrations_provider_label")}</FormLabel>
      <VStack spacing={3} align="stretch">
        {providers.map((provider) => (
          <Box
            key={provider.id}
            p={4}
            border="2px"
            borderColor={selectedProvider?.id === provider.id ? `${provider.color}.500` : borderColor}
            borderRadius="lg"
            cursor="pointer"
            bg={selectedProvider?.id === provider.id ? `${provider.color}.50` : "transparent"}
            _hover={{
              borderColor: `${provider.color}.300`,
              bg: `${provider.color}.25`,
            }}
            onClick={() => onProviderSelect(provider)}
          >
            <HStack spacing={3}>
              <Icon as={provider.icon} boxSize={6} color={`${provider.color}.500`} />
              <VStack align="start" spacing={1} flex={1}>
                <Text fontWeight="semibold" color={textColor}>
                  {provider.name}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  {t(provider.description)}
                </Text>
              </VStack>
            </HStack>
          </Box>
        ))}
      </VStack>
    </FormControl>
  );
};

export default ProviderSelection; 